import { render, staticRenderFns } from "./OfferDetails.vue?vue&type=template&id=c6937fe6&scoped=true"
import script from "./OfferDetails.vue?vue&type=script&lang=js"
export * from "./OfferDetails.vue?vue&type=script&lang=js"
import style0 from "./OfferDetails.vue?vue&type=style&index=0&id=c6937fe6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6937fe6",
  null
  
)

export default component.exports